import type { AiToolData } from "./AiTooling.types";

export const aiTools: AiToolData[] = [
  {
    name: "Claude",
    role: "Pair-programming, architecture reasoning, code review",
    position: "top",
    logoSrc: "/images/how-work/logos/claude.svg",
  },
  {
    name: "Cursor",
    role: "Refactors, multi-file edits, codebase navigation",
    position: "right",
    logoSrc: "/images/how-work/logos/cursor.svg",
  },
  {
    name: "Copilot",
    role: "In-editor completions for routine code",
    position: "bottom",
    logoSrc: "/images/how-work/logos/copilot.svg",
  },
  {
    name: "Internal QA agents",
    role: "Test plan generation and regression coverage",
    position: "left",
    logoSrc: "/images/how-work/logos/qa-agent.svg",
  },
];
